import { AppConfig } from '../types';

export const config: AppConfig = {
  dashboardApi: process.env.REACT_APP_DASHBOARD_API || '',
  whatsappApi: process.env.REACT_APP_WHATSAPP_API || '',
  stage: process.env.REACT_APP_STAGE || 'dev',
  apiForClient: process.env.REACT_APP_API_FOR_CLIENT_URL || '',
};

export const authConfig = {
  authUrl: process.env.REACT_APP_AUTH_URL || 'https://uxumwgj2gk.execute-api.us-west-2.amazonaws.com',
};

// Validation
if (!config.dashboardApi) {
  throw new Error('REACT_APP_DASHBOARD_API is required');
}

if (!config.whatsappApi) {
  throw new Error('REACT_APP_WHATSAPP_API is required');
}

export default config;